module.exports = __webpack_public_path__ + "static/media/select-icon.73cd761a.svg";